/*code reference from @material_ui component Dialog https://material-ui.com/components/dialogs/*/

import React from "react";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from '@material-ui/core/styles';
import MuiDialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import CreationSuite from '../../../../containers/Content/CreationSuite';
import Close from "../../../../site_media/images/icons8-close-window-24.png";

const CustomDialog = withStyles((theme) => ({
    paper: {
        borderRadius: "10px",
        padding: "8px",
        maxWidth:"1060px"
    },
}))(MuiDialog);
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});
function CustomCreationSuitePopup(props) {
    return (
        <div>
            <CustomDialog
                open={true}
                TransitionComponent={Transition}
                onClose={() => (props.closeCreationSuite())}
            >
                <DialogTitle>
                    <img className="upload-popup-close" src={Close} alt={"X"} onClick={() => (props.closeCreationSuite())} style={{ cursor: 'pointer' }} />
                </DialogTitle>
                <DialogContent>
                    <div>
                        <CreationSuite 
                            fileData = {props.fileData}
                            handleCreationSuiteUpload={(data)=>(props.handleCreationSuiteUpload(data))}
                            onClose = {()=>(props.closeCreationSuite())}/>
                    </div>
                </DialogContent>

                <DialogActions>

                </DialogActions>
            </CustomDialog>
        </div>
    );

}

export default CustomCreationSuitePopup;